import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from "../../../../../../_metronic/_partials/controls";
import NoticeEditForm from "./NoticeEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import * as actions from "../../../_redux/notices/NoticesActions";
import { toast } from "react-hot-toast";

export function NoticeEdit({
  history,
  match: {
    params: { id },
  },
}) {
  const backToNoticesList = () => {
    history.push(`/operation/notices/${id}/view`);
  };

  const subHeader = useSubheader();

  const [title, setTitle] = useState("");
  const dispatch = useDispatch();

  const { actionsLoading, noticeToView } = useSelector(
    (state) => ({
      actionsLoading: state.notices.actionsLoading,
      noticeToView: state.notices.noticeToView,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchNotice(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = `ویرایش اطلاعیه ${noticeToView?.name ?? ""}`;
    setTitle(_title);

    subHeader.setTitle(_title);
  }, [noticeToView, id]);

  const saveNotice = (values) => {
    dispatch(actions.updateNotice(values))
      .then(() => {
        backToNoticesList();
        toast.success("اطلاعیه با موفقیت تغییر کرد");
      })
      .catch(() => {
        toast.error("خطا در تغییر اطلاعیه");
      });
  };

  const btnRef = useRef();

  const saveNoticeClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type={"button"}
            onClick={backToNoticesList}
            className={"btn btn-light"}
          >
            <i className={"fa fa-arrow-left"} />
            برگشت
          </button>
          <> </>
          <button
            type={"button"}
            className={"btn btn-primary ml-2"}
            onClick={saveNoticeClick}
          >
            ذخیره
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <NoticeEditForm
          notice={noticeToView}
          btnRef={btnRef}
          saveNotice={saveNotice}
        />
      </CardBody>
    </Card>
  );
}
